import { Button, Box, Typography, Divider } from "@mui/material";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import ReplayIcon from "@mui/icons-material/Replay";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import { useNavigate } from "react-router-dom";
import { borderRadius, shadows } from "../../utils/designSystem";

type Props = {
  onClickPreviousClip: () => void;
  onClickReplayClip: () => void;
  onClickNextClip: () => void;
  isPreviousClipDisabled: boolean;
  isReplayClipDisabled: boolean;
  isNextClipDisabled: boolean;
  setToSearchEditMode: () => void;
};

export const VideoReviewNavigation = ({
  onClickPreviousClip,
  onClickReplayClip,
  onClickNextClip,
  isPreviousClipDisabled,
  isReplayClipDisabled,
  isNextClipDisabled,
  setToSearchEditMode,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        p: 3,
        mb: 3,
        borderRadius: borderRadius.lg,
        border: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
        boxShadow: shadows.sm,
      }}
    >
      <Typography
        variant="h6"
        component="h3"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: "text.primary",
        }}
      >
        Navigation & Controls
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
        <Button
          onClick={() => {
            setToSearchEditMode();
            navigate("/video-review");
          }}
          variant="outlined"
          color="primary"
          startIcon={<SearchIcon />}
          sx={{
            borderRadius: borderRadius.md,
            textTransform: "none",
            fontWeight: 500,
            px: 3,
          }}
        >
          New Search
        </Button>
        <Button
          onClick={() => setToSearchEditMode()}
          variant="outlined"
          color="primary"
          startIcon={<EditIcon />}
          sx={{
            borderRadius: borderRadius.md,
            textTransform: "none",
            fontWeight: 500,
            px: 3,
          }}
        >
          Modify Search
        </Button>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <Button
          onClick={onClickPreviousClip}
          startIcon={<SkipPreviousIcon />}
          variant="contained"
          disabled={isPreviousClipDisabled}
          sx={{
            borderRadius: borderRadius.md,
            textTransform: "none",
            fontWeight: 500,
            px: 3,
            boxShadow: shadows.sm,
            "&:hover": {
              boxShadow: shadows.md,
            },
          }}
        >
          Previous
        </Button>
        <Button
          onClick={onClickReplayClip}
          startIcon={<ReplayIcon />}
          variant="contained"
          color="primary"
          disabled={isReplayClipDisabled}
          sx={{
            borderRadius: borderRadius.md,
            textTransform: "none",
            fontWeight: 500,
            px: 3,
            boxShadow: shadows.sm,
            "&:hover": {
              boxShadow: shadows.md,
            },
          }}
        >
          Replay
        </Button>
        <Button
          onClick={onClickNextClip}
          endIcon={<SkipNextIcon />}
          variant="contained"
          disabled={isNextClipDisabled}
          sx={{
            borderRadius: borderRadius.md,
            textTransform: "none",
            fontWeight: 500,
            px: 3,
            boxShadow: shadows.sm,
            "&:hover": {
              boxShadow: shadows.md,
            },
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};
